import React from 'react'
import cn from 'classnames'
import s from './InputNumber.module.scss'

interface Props {
  value: number | string
  onChange: (value: number) => void
  placeholder?: string
  className?: string
  disabled?: boolean
}
const defaultProps = {
  placeholder: undefined,
  className: undefined,
  disabled: false,
}
const InputNumber = ({
  value,
  onChange,
  placeholder,
  className,
  disabled,
}: Props): JSX.Element => (
  <input
    data-testid="input-number"
    className={cn(s.input, className, { [s.disabled]: disabled })}
    type="text"
    inputMode="numeric"
    pattern="[0-9]*"
    placeholder={placeholder}
    value={value}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
      // Replace space - https://stackoverflow.com/a/51399843
      const n = e.target.value.replace(/[\u202F\u00A0\u2000\u2001\u2003]/, '')
      onChange(parseInt(n, 10))
    }}
    disabled={disabled}
  />
)

InputNumber.defaultProps = defaultProps
export default InputNumber
